import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import MetricChart from "./metric-chart/metric-chart";
import { ReactComponent as NegativeIcon } from "assets/icons/negative-smile.svg";
import { ReactComponent as PositiveIcon } from "assets/icons/smile.svg";
import { ReactComponent as NeutralIcon } from "assets/icons/neutral-smile.svg";

import s from "./metrics.module.scss";

const Metrics = (props) => {

    const [title, setTitle] = useState(props.metricsData.title ? props.metricsData.title : 'METRICS');
    const [totalCount, setTotalCount] = useState(props.metricsData.total);
    const [chartTotal, setChartTotal] = useState(props.metricsData.chartTotal ? props.metricsData.chartTotal : null);
    const [data, setData] = useState(props.metricsData);
    const [colors, setColors] = useState(props.metricsData.colors);
    const [labelText, setLabelText] = useState(props.metricsData.labelText ? props.metricsData.labelText : null);
    const [annotation, setAnnotation] = useState(props.metricsData.annotation ? props.metricsData.annotation : null);

    useEffect(() => {
        setTitle(props.metricsData.title ? props.metricsData.title : 'METRICS');
        setTotalCount(props.metricsData.total);
        setChartTotal(props.metricsData.chartTotal ? props.metricsData.chartTotal : null);
        setData(props.metricsData);
        setColors(props.metricsData.colors);
        setLabelText(props.metricsData.labelText ? props.metricsData.labelText : null);
        setAnnotation(props.metricsData.annotation ? props.metricsData.annotation : null);
    }, [props.metricsData, props.selectedLanguage]);

    const getIcon = (field, index) => {
        switch(field){
            case 'NEGATIVE':
                return <NegativeIcon />
            case 'NEUTRAL':
                return <NeutralIcon />
            case 'POSITIVE':
                return <PositiveIcon />
            case 'UNDEFINED':
                return <NeutralIcon />
            default:
                return <div className={s.Item} style={{background: colors[index]}}></div>
        }
    }

    const getPercent = (value, sum) => {
        let percent = (value / sum) * 100;
        return Math.round(percent * 10) / 10;
    }

    const formatNumber = (x) => {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
      }

    const metricItems = data && data.data.length ? data.data.map((k, i) =>  
        <div className={s.MetricItem} key={i} >
            {/*<div className={s[k.list]}>{getSmile(k.list)}</div>
            <span className={s.itemName}>{k.name}</span>
            <span className={s.itemValue}>{formatNumber(k.data)}</span>
            <span className={s.itemPercent}>{getPercent(k.data, totalCount).toFixed(0)+"%"}</span>*/}
            <div className={data.fields ? s[data.fields[i]] : ''}>{data.fields ? getIcon(data.fields[i], i) : ''}</div>
            <span className={s.itemName}>{ data.fields ? props.getValue(data.fields[i]) : 0 }</span>
            <span className={s.itemValue}>{formatNumber(k)}</span>
            <span className={s.itemPercent}>{getPercent(k, chartTotal ? chartTotal : totalCount)+"%"}</span>
        </div>
    ) : <div>no data</div>;

    return <div className={s.Metrics}>
        <h1>{props.getValue(title)}</h1>
        <div className="formRow">
            <span className="labelText">{labelText ? props.getValue(labelText) : props.getValue('TOTAL_MENTION')}</span>
            {formatNumber(totalCount)}
        </div>
        {data && data.data.length > 1 ? <MetricChart getValue={props.getValue} labels={data.fields} items={data.data} total={chartTotal ? chartTotal : totalCount} colors={colors} getPercent={getPercent}/> : null}
        <div className={s.MetricsItems}>
            {annotation 
                        ?   <div className={s.annotationText}>
                                <span>{props.getValue(annotation.text)} - </span>
                                <span className={s.annotationTitle}>"{annotation.title}"</span>
                            </div> 
                        : null}
            <div className={s.MetricsItems}>
                {metricItems}
            </div>
        </div>
    </div>
}

export default Metrics;